export default __webpack_public_path__ + "static/stairs-7b36eec2debc9c19c40c92106cc69def.jpg";